
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useAnalytics } from '@/hooks/useAnalytics';

const HeroContent = () => {
  const navigate = useNavigate();
  const { trackCTAClick, trackOnboardingStart } = useAnalytics();

  const handleGetEarlyAccess = () => {
    trackCTAClick('hero');
    trackOnboardingStart();
    navigate('/early-access');
  };

  return (
    <div className="text-center lg:text-left space-y-8">
      <div className="space-y-6">
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-white leading-tight tracking-tight">
          Don't overthink it.
          <span className="block text-yellow-400">Show up again.</span>
        </h1>
        
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white/90 leading-relaxed">
          The app that comes before habits & goals
        </h2>
        
        <p className="text-xl md:text-2xl text-white/80 font-medium max-w-2xl leading-relaxed">
          Simple commitments. Real results. No forever pressure. Powered by AI that actually gets you.
        </p>
      </div>

      {/* CTA */}
      <div className="space-y-6">
        <Button 
          onClick={handleGetEarlyAccess}
          className="bg-yellow-400 text-purple-900 hover:bg-yellow-300 text-xl font-black px-12 py-6 rounded-2xl transition-all duration-300 hover:scale-105 shadow-2xl"
        >
          Get Early Access
        </Button>
        
        {/* Social Proof */}
        <div className="flex items-center justify-center lg:justify-start gap-3">
          <div className="flex -space-x-2">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="w-8 h-8 bg-gradient-to-br from-yellow-400 to-orange-400 rounded-full border-2 border-white"></div>
            ))}
          </div>
          <span className="text-white/90 font-medium">67 people ready to show up</span>
        </div>
        
        <p className="text-white/70 text-sm font-medium">
          App launching soon • Limited beta spots available
        </p>
      </div>
    </div>
  );
};

export default HeroContent;
